import React, { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import { schedulingFetchGet } from "app/utils/request/scheduling/fetch";
import { useSelector } from "react-redux";
import { RootState } from "typedefs";
import CustomerTable from "./CustomerTable";
import NoCustomersPlaceholder from "./NoCustomersPlaceholder";
import { formatDate } from "../../../utils/luxonFormats";
import ButtonVariant from "app/components/Button/ButtonVariant";

interface Customer {
  studentProfileId: number;
  email: string;
  firstName: string;
  lastName: string;
  profilePicture: string;
  totalSpent: string;
  remainingSessions: number;
  totalSessions: number;
  payments: number;
  date: string;
  currency: string;
  unlimited: boolean;
}

interface CustomersProps {
  stripeIntegrationEnabled?: boolean;
  apiPath?: string;
  basePath?: string;
  facilityId?: string;
}

export default function Customers({
  stripeIntegrationEnabled,
  apiPath,
  basePath = "/billing",
  facilityId,
}: CustomersProps) {
  const { t } = useTranslation();
  const [customers, setCustomers] = useState<Customer[]>([]);
  const userId = useSelector((state: RootState) => state.user.self.id);

  const defaultPath = `/stripe_purchases/customers?coach_id=${userId}`;
  const endpoint = apiPath || defaultPath;

  useEffect(() => {
    schedulingFetchGet(endpoint)
      .then((data) => {
        if (!data) {
          throw new Error("Unexpected response format");
        }
        setCustomers(data);
      })
      .catch((error) => {
        console.error("Failed to fetch customers:", error);
      });
  }, [endpoint]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>{t("Customers")}</h2>
        {stripeIntegrationEnabled && (
          <ButtonVariant
            title={t("Go to Stripe")}
            buttonType='primary-outline'
            onClickFunc={() =>
              window.open("https://dashboard.stripe.com/customers", "_blank")
            }
            buttonStyles={styles.xxx}
          />
        )}
      </div>

      {customers.length > 0 ? (
        <CustomerTable
          customers={customers}
          formatDate={formatDate}
          basePath={basePath}
          facilityId={facilityId}
          stripeIntegrationEnabled={stripeIntegrationEnabled}
        />
      ) : (
        <NoCustomersPlaceholder />
      )}
    </div>
  );
}
